import { Fragment, PropsWithChildren } from 'react';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import Button from '../Button';
import CloseIcon from '../../../assets/icons/General/close.svg?react';

export default function Modal({
  open,
  modalClassName,
  title,
  subTitle,
  closeButton,
  handleClose,
  children,
}: PropsWithChildren<{
  open: boolean;
  modalClassName?: string;
  title?: string;
  subTitle?: string;
  closeButton?: boolean;
  handleClose?: (() => void) | undefined;
}>) {
  const handleCloseWrapper = () => handleClose && handleClose();
  return (
    <>
      <Transition appear show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[99]"
          onClose={handleCloseWrapper}
        >
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-75"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-75"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="bg-black-900/75 fixed inset-0 backdrop-blur-xs" />
          </TransitionChild>

          {/* )} */}
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <TransitionChild
                as={Fragment}
                enter="ease-out duration-75"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-75"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <DialogPanel
                  className={`shadow-[0px_20px_24px_-4px_#10182814]transition-all relative transform overflow-hidden rounded-3xl bg-white p-6 text-left align-middle ${modalClassName}`}
                >
                  {closeButton && (
                    <Button
                      variant="ghost"
                      type="button"
                      className={`absolute top-3 right-3 inline-flex items-center rounded-lg`}
                      onClick={handleClose}
                    >
                      <CloseIcon className="stroke-black-500 w-[10px]" />
                      <span className="sr-only">Close this modal</span>
                    </Button>
                  )}
                  {title && (
                    <DialogTitle
                      as="h3"
                      className="text-black-900 pr-4 pb-2 text-lg leading-6 font-semibold"
                    >
                      {title}
                    </DialogTitle>
                  )}
                  {subTitle && (
                    <div className="mt-2">
                      <p className="text-black-600 text-sm">{subTitle}</p>
                    </div>
                  )}
                  {children}
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
